import { watch, ref, onUnmounted } from 'vue'
import { useFormStore } from '@/stores/form'
import useCommonFun from '@/composables/useCommonFun'

const dateOfBirthWatch = () => {
  const birthDateWatch = ref()
  const formStore = useFormStore()
  birthDateWatch.value = watch(
    () => formStore.form.values.dateOfBirth,
    (newVal) => {
      if (newVal && useCommonFun().ageComparison(newVal, 15, '>')) {
        formStore.extraMap = {
          ...formStore.extraMap,
          showQualificationLevel: true,
          showWorkType: true,
          showChangePersonPhoto: true
        }
      }
    }
  )
  onUnmounted(() => {
    birthDateWatch.value && birthDateWatch.value()
  })
}
export default function () {
  return {
    dateOfBirthWatch
  }
}
